module.exports = __webpack_public_path__ + "img/Yam.6f29f1b6.jpg";